<nav class="page-navigation-container" id="PageNavigation" #nav>
  <ul class="scrollbar scrollbar-hoverable">
    <li *ngFor="let nav of navigation" [innerHTML]="nav.title" (click)="onNavClick(nav.index)"></li>
  </ul>
</nav>

